<template>
  <div class="detail-header line">
    <img :src="character.sketch" :alt="character.fullname"/>
    <div class="detail-header-info column">
      <h1>{{ character.shortname | format }}</h1>
      <p>{{ character.party | titleCase }}</p>
      <p>{{ character.candidate }}</p>
      <p>{{ character.age }}</p>
      <p>{{ character.city | titleCase }}</p>
      <p>{{ character.years }} años en el Congreso</p>
      <p>Sueldo mensual bruto: <strong>$29'814.276</strong></p>
      <p>Sueldo anual bruto: <strong>{{ character.income.anual }}</strong></p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['character'],
  filters: {
    format (str) {
      if (!str) return
      return str.replace(/-/g, ' ')
    },
    titleCase (str) {
      if (!str) return
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    }
  }
}
</script>

<style scoped>
.detail-header {
  align-items: center;
  margin-bottom: 20px;
}
.detail-header img {
  max-width: 100px;
}
.detail-header-info {
    margin-left: 20px;
}
.detail-header-info h1 {
  margin: 10px 0;
}
.detail-header-info p {
  font-size: small;
  margin: 0 0 2px;
}
@media only screen and (min-width: 768px) {
  .detail-header img {
    max-width: 200px;
  }
  .detail-header-info p {
    font-size: medium;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/Header.vue